import React, { useContext, useRef } from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import Switch from "react-switch";
import { useTranslation } from "react-i18next";
import Global from "../../util/Global";
import { AlertContext } from "../../util/Alerter";
import { LoaderComponent } from "../../util/Loader";
import { GlobalData } from "../../util/GlobalData";
import { Autocomplete, Button, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import ImageUploader from "../ImageUploader";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import CategoryIcon from '@mui/icons-material/Category';
import HiveIcon from '@mui/icons-material/Hive';
import DescriptionIcon from '@mui/icons-material/Description';
import FilterListIcon from '@mui/icons-material/FilterList';
import TransformIcon from '@mui/icons-material/Transform';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import ScaleIcon from '@mui/icons-material/Scale';
import HeightIcon from '@mui/icons-material/Height';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import { useNavigate } from "react-router-dom";
import { CurrencyContext, DeliveryCountryContext, QrScanner } from "../Utils";
import { CurrencySelectorComponent } from "../CurrencySelector";
import QrCode2Icon from '@mui/icons-material/QrCode2';
import CameraAlt from '@mui/icons-material/CameraAlt';
import CloudUpload from '@mui/icons-material/CloudUpload';

// import { moveFile } from "move-file";
// const moveFile = require("@npmcli/move-file");
// const cpFile = require("cp-file");

export default function ProductEditComponent({ productResponseData }) {
  const { t, } = useTranslation();
  const navigate = useNavigate()

  const { showAlert } = useContext(AlertContext)
  const { currency, getCurrencyPrice } = useContext(CurrencyContext)
  const [productCurrency, setproductCurrency] = useState(currency)
  const [isLoading, setisloading] = useState(false)
  const maxImages = 5;


  // API input data
  const {countries}=useContext(DeliveryCountryContext)


  const [nom, setNom] = useState("");
  const [traceabilityURL, settraceabilityURL] = useState("");
  const [description, setDescription] = useState("");
  const [stock, setStock] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [price, setPrice] = useState(0);
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(0);
  const [typologie, setTypologie] = useState("");
  const [datedepeche, setDatedepeche] = useState(dayjs(new Date()));
  const [methodedecapture, setMethodedecapture] = useState("");
  const [productionCountry, setProductionCountry] = useState("");
  const [deliveryCountries, setdeliveryCountries] = useState([]);
  const [transformation, setTransformation] = useState("");
  const [conservation, setConservation] = useState("");
  const [congelation, setCongelation] = useState("");
  const [glazing, setGlazing] = useState(0);
  const [taille, setTaille] = useState(0);
  const [certification, setCertification] = useState("");
  const [emballage, setEmballage] = useState("");
  const [poidemballage, setPoidemballage] = useState(0);
  const [isVisible, setisVisible] = useState(false)
  const [images, setImages] = useState([]);

  const qrScannerRef = useRef(null);


  const handleScanSuccess = (data) => {
    if (!data.includes("http")) {
      setErrors({ traceabilityURL: true })
      settraceabilityURL("")
      return
    }
    settraceabilityURL(data);
  };

  const handleError = (err) => {
    setErrors({ traceabilityURL: true })
    settraceabilityURL("")
  };

  const handleTakeImage = () => {
    if (qrScannerRef.current) {
      qrScannerRef.current.startCameraScan();
    }
  };

  const handleUploadImage = () => {
    if (qrScannerRef.current) {
      qrScannerRef.current.triggerFileUpload();
    }
  };

  const [errors, setErrors] = useState({
    nom: false,
    traceabilityURL: false,
    description: false,
    stock: false,
    discount: false,
    price: false,
    min: false,
    max: false,
    typologie: false,
    datedepeche: false,
    methodedecapture: false,
    productionCountry: false,
    deliveryCountries: false,
    transformation: false,
    conservation: false,
    congelation: false,
    glazing: false,
    taille: false,
    certification: false,
    emballage: false,
    poidemballage: false,
    images: false,
  });


  const IMAGE_TEST_URL = Global.backend + "/index.php/produit/newImage";
  const ADD_PRODUCT_URL = Global.backend + "/index.php/api/produit/new";
  const UPDATE_PRODUCT_URL = Global.backend + "/index.php/api/produit/modifierProduit";



  useEffect(() => {
      checkProvidedProduct()
  }, [])



  const onImageDelete = async (imageId) => {
    const DELETE_IMAGE_URL = Global.backend + "/index.php/produit/deleteImage";

    try {
      return await axios.post(DELETE_IMAGE_URL, { imageId });
    } catch (err) {
      showAlert("error", t("request.errorDeleteImage"));
      throw ""
    }
  }


  // check if we already passed product details
  const checkProvidedProduct = () => {
    if (!productResponseData) {
      return
    }

    const normalizedDeliveryCountries = Array.isArray(productResponseData.deliveryCountries)
      ? productResponseData.deliveryCountries
      : (typeof productResponseData.deliveryCountries === "string"
        ? productResponseData.deliveryCountries.split(",").map((country) => country.trim()).filter(Boolean)
        : [])

    setNom(productResponseData.nom);
    settraceabilityURL(productResponseData.traceabilityURL)
    setDescription(productResponseData.description);
    setTypologie(productResponseData.typologie);
    setDatedepeche(dayjs(new Date(productResponseData.datedepeche)))
    setMethodedecapture(productResponseData.methodedecapture);
    setProductionCountry(productResponseData.productionCountry);
    setdeliveryCountries(normalizedDeliveryCountries)
    setTransformation(productResponseData.transformation);
    setConservation(productResponseData.conservation);
    setCongelation(productResponseData.congelation);
    setGlazing(productResponseData.glazing);
    setTaille(productResponseData.taille);
    setCertification(productResponseData.certification);
    setEmballage(productResponseData.emballage);
    setPoidemballage(productResponseData.poidemballage);
    setStock(productResponseData.stock);
    setDiscount(productResponseData.discount);
    setPrice(productResponseData.prix);
    setproductCurrency(productResponseData.currency)
    setMin(productResponseData.min);
    setMax(productResponseData.max);
    setImages(productResponseData.image);
    setisVisible(productResponseData.visibilite);
  }



  const checkInputs = () => {
    const errors = {
      nom: nom.length < 4,
      traceabilityURL: !traceabilityURL.includes("http"),
      description: description.length < 5,
      stock: stock <= 0,
      discount: discount < 0 || discount > 100,
      price: price <= 0,
      min: min <= 0,
      max: max <= 0,
      typologie: !typologie,
      datedepeche: !datedepeche.isValid(),
      methodedecapture: !methodedecapture,
      productionCountry: !productionCountry,
      deliveryCountries: !deliveryCountries.length,
      transformation: !transformation,
      conservation: !conservation,
      congelation: !congelation,
      glazing: glazing <= 0,
      taille: taille <= 0,
      certification: !certification,
      emballage: !emballage,
      poidemballage: poidemballage <= 0,
      images: images.length === 0,
    };

    setErrors(errors)



    const hasErrors = Object.values(errors).some(error => error)

    if (hasErrors) {
      let errorMessage = ""

      if (errors.nom || errors.typologie || errors.description || errors.traceabilityURL) {
        errorMessage = t("product.verifydetails")
      } else if (errors.datedepeche || errors.methodedecapture || errors.productionCountry) {
        errorMessage = t("product.verifyproductionDetails")
      } else if (errors.transformation || errors.conservation || errors.glazing) {
        errorMessage = t("product.verifyprocessingDetails")
      } else if (errors.certification || errors.emballage || errors.poidemballage) {
        errorMessage = t("product.verifypackagingAndCert")
      } else {
        errorMessage = t("product.verifyspecs")
      }

      showAlert("error", errorMessage)
    }


    return !hasErrors
  }



  function onSubmit() {
    if (!checkInputs()) {
      return
    }

    setisloading(true);

    const formData = new FormData();




    formData.append('nom', nom);
    formData.append("traceabilityURL", traceabilityURL)
    formData.append('description', description);
    formData.append('typologie', typologie);
    formData.append('datedepeche', datedepeche);
    formData.append('methodedecapture', methodedecapture);
    formData.append('productionCountry', productionCountry);
    formData.append("deliveryCountries", deliveryCountries)
    formData.append('transformation', transformation);
    formData.append('conservation', conservation);
    formData.append('congelation', congelation);
    formData.append('glazing', glazing);
    formData.append('taille', taille);
    formData.append('certification', certification);
    formData.append('emballage', emballage);
    formData.append('poidemballage', poidemballage);
    formData.append('stock', stock);
    formData.append('prix', price);
    formData.append("currency", productCurrency)
    if (discount) {
      formData.append('discount', discount);
    }
    formData.append('min', min);
    formData.append('max', max);
    formData.append('visibilite', isVisible);






    if (!productResponseData) {
      // add product

      images.forEach((image, index) => {
        formData.append(`assets[${index}]`, image.file);
      });

      axios
        .post(ADD_PRODUCT_URL, formData)
        .then((response) => {
          if (response.data.message == "ok") {
            showAlert("success", t("request.successAddProduct"))
            navigate("/dashboard/user/myproducts")
          } else {
            throw ""
          }
        }).catch((err) => {
          showAlert("error", t("request.errorAddProduct"))
        })
        .finally(() => {
          setisloading(false);
        });
    } else {
      // update product
      formData.append("produitId", productResponseData.id);


      images.forEach((image, index) => {
        if (!image.imageURL) {
          // only add local images and not already uploaded images
          formData.append(`assets[${index}]`, image.file);
        }
      });

      axios
        .post(UPDATE_PRODUCT_URL, formData)
        .then((response) => {
          showAlert("success", t("request.successUpdateProduct"))
        }).catch((err) => {
          showAlert("error", t("request.errorUpdateProduct"))
        })
        .finally(() => {
          setisloading(false);
        });
    }


  }


  return (
    <LoaderComponent isLoading={isLoading}>

      <div className="container-fluid">

        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div
                  id="addproduct-nav-pills-wizard"
                  className="twitter-bs-wizard"
                >
                  <div className=" twitter-bs-wizard-tab-content">
                    <div
                      className="toggle-switch-admin row d-flex align-items-center justify-content-center"
                      style={{ color: "red" }}
                    >
                      {isVisible ? (
                        <span
                          style={{
                            color: "white",
                            backgroundColor: "green",
                            fontSize: 14,
                            fontWeight: "bold",
                            borderRadius: 15,
                            padding: 2,
                            marginBottom: 5,
                            textAlign: "center",
                          }}
                        >
                          {t("product.visible")}
                        </span>
                      ) : (
                        <span
                          style={{
                            color: "white",
                            backgroundColor: "red",
                            fontSize: 14,
                            fontWeight: "bold",
                            borderRadius: 15,
                            padding: 2,
                            marginBottom: 5,
                            textAlign: "center",
                          }}
                        >
                          {t("product.invisible")}
                        </span>
                      )}
                      <Switch onChange={() => setisVisible(!isVisible)} checked={isVisible} />
                    </div>




                    <div className="tab-pane" id="basic-info">
                      <h4 className="card-title">{t("product.details")}</h4>
                      <p className="card-title-desc"></p>


                      <div className="row mb-3">
                        <div className="col-6">
                          <TextField value={nom} error={errors.nom} fullWidth variant="outlined" type="text" label={t("product.nom")} onChange={(e) => setNom(e.target.value)}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <DriveFileRenameOutlineIcon />
                                </InputAdornment>
                              )
                            }} />
                        </div>
                        <div className="col-6">
                          <FormControl error={errors.typologie} fullWidth>
                            <InputLabel>{t("product.typologie")}</InputLabel>
                            <Select
                              IconComponent={HiveIcon}
                              value={typologie}
                              label={t("product.typologie")}
                              onChange={(e) => setTypologie(e.target.value)}
                            >
                              {GlobalData.product.typologies.map((val, index) => {
                                return (
                                  <MenuItem key={index} value={val}>{t("product.typologies." + val)}</MenuItem>
                                )
                              })}
                            </Select>
                          </FormControl>
                        </div>
                      </div>


                      <div className="row mb-3">
                        <div className="col-4">
                          <TextField
                            value={traceabilityURL}
                            error={errors.traceabilityURL}
                            fullWidth
                            variant="outlined"
                            type="text"
                            label={t("product.traceabilityURL")}
                            onChange={(e) => settraceabilityURL(e.target.value)}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <QrCode2Icon />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>

                        <div className="col-2">
                          <Button
                            className="btn btn-primary"
                            variant="contained"
                            startIcon={<CameraAlt />}
                            onClick={handleTakeImage}
                          >
                            {t("scanQr")}
                          </Button>
                        </div>

                        <div className="col-1">
                          <p>{t("or")}</p>
                        </div>


                        <div className="col-2">
                          <Button
                            className="btn btn-primary"
                            variant="contained"
                            startIcon={<CloudUpload />}
                            onClick={handleUploadImage}
                          >
                            {t("uploadQR")}
                          </Button>
                        </div>

                        <div className="col-5">
                          <QrScanner
                            ref={qrScannerRef}
                            onScanSuccess={handleScanSuccess}
                            onError={handleError}
                          />
                        </div>
                      </div>


                      <div className="mb-3">
                        <TextField
                          error={errors.description}
                          fullWidth
                          multiline
                          rows={4}
                          variant="outlined"
                          label={t("product.description")}
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <DescriptionIcon />
                              </InputAdornment>
                            )
                          }}
                        />
                      </div>
                    </div>




                    <hr />




                    <div className="tab-pane" id="basic-info">
                      <h4 className="card-title">{t("product.productionDetails")}</h4>
                      <p className="card-title-desc"></p>


                      <div className="row mb-3">
                        <div className="col-3">
                          <DatePicker error={errors.datedepeche} fullWidth label={t("product.datedepeche")} value={datedepeche} onChange={setDatedepeche} />
                        </div>


                        <div className="col-5">
                          <FormControl error={errors.methodedecapture} fullWidth>
                            <InputLabel>{t("product.capture")}</InputLabel>
                            <Select
                              IconComponent={FilterListIcon}
                              value={methodedecapture}
                              label={t("product.capture")}
                              onChange={(e) => setMethodedecapture(e.target.value)}
                            >
                              {GlobalData.product.captures.map((val, index) => {
                                return (
                                  <MenuItem key={index} value={val}>{t("product.captures." + val)}</MenuItem>
                                )
                              })}
                            </Select>
                          </FormControl>
                        </div>


                        <div className="col-4">
                          <Autocomplete
                            disablePortal
                            fullWidth
                            options={countries.map((val) => ({
                              label: val.name,
                              value: val.name
                            }))}
                            value={productionCountry}
                            onChange={(event, newValue) => {
                              setProductionCountry(newValue?.value);
                            }}
                            renderInput={(params) => (
                              <TextField error={errors.productionCountry} {...params} label={t("product.productionCountry")} variant="outlined" />
                            )}
                            disableClearable={true}
                          />
                        </div>
                      </div>
                    </div>


                    <hr />


                    <div className="tab-pane" id="basic-info">
                      <h4 className="card-title">{t("product.processingDetails")}</h4>
                      <p className="card-title-desc"></p>


                      <div className="row mb-3">
                        <div className="col-3">
                          <FormControl error={errors.transformation} fullWidth>
                            <InputLabel>{t("product.transformation")}</InputLabel>
                            <Select
                              IconComponent={MoveUpIcon}
                              value={transformation}
                              label={t("product.transformation")}
                              onChange={(e) => setTransformation(e.target.value)}
                            >
                              {GlobalData.product.transformations.map((val, index) => {
                                return (
                                  <MenuItem key={index} value={val}>{t("product.transformations." + val)}</MenuItem>
                                )
                              })}
                            </Select>
                          </FormControl>
                        </div>
                        <div className="col-3">
                          <FormControl error={errors.conservation} fullWidth>
                            <InputLabel>{t("product.conservation")}</InputLabel>
                            <Select
                              IconComponent={TransformIcon}
                              value={conservation}
                              label={t("product.conservation")}
                              onChange={(e) => setConservation(e.target.value)}
                            >
                              {GlobalData.product.conservations.map((val, index) => {
                                return (
                                  <MenuItem key={index} value={val}>{t("product.conservations." + val)}</MenuItem>
                                )
                              })}
                            </Select>
                          </FormControl>
                        </div>
                        <div className="col-3">
                          <FormControl error={errors.congelation} fullWidth>
                            <InputLabel>{t("product.congelation")}</InputLabel>
                            <Select
                              IconComponent={AcUnitIcon}
                              value={congelation}
                              label={t("product.congelation")}
                              onChange={(e) => setCongelation(e.target.value)}
                            >
                              {GlobalData.product.congelations.map((val, index) => {
                                return (
                                  <MenuItem key={index} value={val}>{t("product.congelations." + val)}</MenuItem>
                                )
                              })}
                            </Select>
                          </FormControl>
                        </div>
                        <div className="col-3">
                          <TextField
                            error={errors.glazing}
                            fullWidth
                            label={t("product.glazing")}
                            type="number"
                            value={glazing}
                            onChange={(e) => setGlazing(e.target.value)}
                            InputProps={{
                              endAdornment: <InputAdornment position="end"><DeviceThermostatIcon />°C</InputAdornment>,
                            }}
                            variant="outlined"
                          />
                        </div>
                      </div>
                    </div>



                    <hr />




                    <div className="tab-pane" id="basic-info">
                      <h4 className="card-title">{t("product.packagingAndCert")}</h4>
                      <p className="card-title-desc"></p>


                      <div className="row mb-3">
                        <div className="col-4">
                          <FormControl error={errors.certification} fullWidth>
                            <InputLabel>{t("product.certification")}</InputLabel>
                            <Select
                              IconComponent={FactCheckIcon}
                              value={certification}
                              label={t("product.certification")}
                              onChange={(e) => setCertification(e.target.value)}
                            >
                              {GlobalData.product.certifications.map((val, index) => {
                                return (
                                  <MenuItem key={index} value={val}>{t("product.certifications." + val)}</MenuItem>
                                )
                              })}
                            </Select>
                          </FormControl>
                        </div>
                        <div className="col-4">
                          <FormControl error={errors.emballage} fullWidth>
                            <InputLabel>{t("product.emballage")}</InputLabel>
                            <Select
                              IconComponent={Inventory2Icon}
                              value={emballage}
                              label={t("product.emballage")}
                              onChange={(e) => setEmballage(e.target.value)}
                            >
                              {GlobalData.product.emballages.map((val, index) => {
                                return (
                                  <MenuItem key={index} value={val}>{t("product.emballages." + val)}</MenuItem>
                                )
                              })}
                            </Select>
                          </FormControl>
                        </div>
                        <div className="col-4">
                          <TextField
                            error={errors.poidemballage}
                            fullWidth
                            label={t("product.poidemballage")}
                            type="number"
                            value={poidemballage}
                            onChange={(e) => setPoidemballage(e.target.value)}
                            InputProps={{
                              endAdornment: <InputAdornment position="end"><ScaleIcon /> G</InputAdornment>,
                            }}
                            variant="outlined"
                          />
                        </div>

                      </div>
                    </div>


                    <hr />



                    <div className="tab-pane" id="basic-info">
                      <h4 className="card-title">{t("product.specs")}</h4>
                      <p className="card-title-desc"></p>


                      <div className="row mb-3">
                        <div className="col-6">
                          <TextField
                            error={errors.taille}
                            fullWidth
                            label={t("product.taille")}
                            type="number"
                            value={taille}
                            onChange={(e) => setTaille(e.target.value)}
                            InputProps={{
                              endAdornment: <InputAdornment position="end"><HeightIcon /> Cm</InputAdornment>,
                            }}
                            variant="outlined"
                          />
                        </div>
                        <div className="col-6">
                          <TextField
                            error={errors.stock}
                            fullWidth
                            label={t("product.stock")}
                            type="number"
                            value={stock}
                            onChange={(e) => setStock(e.target.value)}
                            InputProps={{
                              endAdornment: <InputAdornment position="end"><InventoryIcon /></InputAdornment>,
                            }}
                            variant="outlined"
                          />
                        </div>
                      </div>



                      <div className="row mb-3">
                        <div className="col-4">
                          <TextField
                            error={errors.price}
                            fullWidth
                            label={t("product.prix")}
                            type="number"
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}
                            InputProps={{
                              endAdornment: <CurrencySelectorComponent fullWidth={true} selectStyle={{ "& .MuiSelect-select": { textOverflow: "initial" } }} blackStyle={true} currency={productCurrency} handleCurrencyChange={(e) => setproductCurrency(e.target.value)} />,
                            }}
                            variant="outlined"
                          />
                        </div>

                        <div className="col-2 d-flex align-items-center">
                          <span
                            className="float-start badge rounded-pill bg-success"
                            style={{ color: "white", fontSize: "1rem" }}
                          >
                            = {GlobalData.currency[currency]} {getCurrencyPrice(price, productCurrency)}
                          </span>
                        </div>

                        <div className="col-6">
                          <TextField
                            error={errors.discount}
                            fullWidth
                            label={t("product.discount")}
                            type="number"
                            defaultValue={0}
                            value={discount}
                            onChange={(e) => setDiscount(e.target.value)}
                            InputProps={{
                              endAdornment: <InputAdornment position="end"><LocalOfferIcon /> %</InputAdornment>,
                            }}
                            variant="outlined"
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col">
                          <TextField
                            error={errors.min}
                            fullWidth
                            label={t("product.minQte")}
                            type="number"
                            value={min}
                            onChange={(e) => setMin(e.target.value)}
                            InputProps={{
                              endAdornment: <InputAdornment position="end"><ShoppingBasketIcon /></InputAdornment>,
                            }}
                            variant="outlined"
                          />
                        </div>
                        <div className="col">
                          <TextField
                            error={errors.max}
                            fullWidth
                            label={t("product.maxQte")}
                            type="number"
                            value={max}
                            onChange={(e) => setMax(e.target.value)}
                            InputProps={{
                              endAdornment: <InputAdornment position="end"><ShoppingBasketIcon /></InputAdornment>,
                            }}
                            variant="outlined"
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col">
                          <Autocomplete
                            multiple
                            disablePortal
                            options={countries}
                            getOptionLabel={(option) => option.name}
                            value={countries.filter((country)=>deliveryCountries?.includes(country.name))}
                            onChange={(event, newValue) => {
                              setdeliveryCountries(newValue.map((value)=>value.name))
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={t("deliveryCountries")}
                                variant="outlined"
                                error={errors.deliveryCountries}
                              />
                            )}
                            isOptionEqualToValue={(option, value) => option.name === value.name}
                            disableClearable={true}
                          />
                        </div>
                      </div>

                      <ImageUploader error={errors.images} images={images} maxImages={maxImages} setImages={setImages} onImageDelete={onImageDelete} setisLoading={setisloading} />
                    </div>











                    <div
                      className="tab-pane"
                      id="metadata"
                      style={{ cursor: "pointer" }}
                    >
                      <ul className="pager wizard twitter-bs-wizard-pager-link">
                        <li
                          className="float-end"
                          style={{ cursor: "pointer" }}
                        >

                          <a onClick={() => { onSubmit() }}>
                            {productResponseData ? t("saveProduct") : t("addProduct")}
                            <i className="mdi mdi-arrow-right ml-1"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoaderComponent>

  )

};
